module.exports = __webpack_public_path__ + "static/Mandiri-4a2cc612f3182f902cd611b2914933d6.svg";